import script from "./HomeProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeProjects.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__